// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3lpvg","buttons":"SendReceipts_buttons__2f664","email":"SendReceipts_email__2ig0y","bookApptTitle":"SendReceipts_bookApptTitle__12Ddx"};